import { render, staticRenderFns } from "./Webcam.vue?vue&type=template&id=4f03507e&scoped=true"
import script from "./Webcam.vue?vue&type=script&lang=ts"
export * from "./Webcam.vue?vue&type=script&lang=ts"
import style0 from "./Webcam.vue?vue&type=style&index=0&id=4f03507e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03507e",
  null
  
)

export default component.exports